import React, { useState, useEffect } from "react";

const API_URL = "https://api.lii.com.co:5101";

const Photos = () => {
  const [photos, setPhotos] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(null);

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        if (!storedUser?._id) return;

        const response = await fetch(`${API_URL}/api/photos/${storedUser._id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });

        if (response.ok) {
          const data = await response.json();
          setPhotos(data);
        } else {
          console.error("❌ Erreur récupération photos :", response.status);
        }
      } catch (error) {
        console.error("❌ Erreur fetch photos :", error);
      }
    };

    fetchPhotos();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleUpload = async () => {
    if (!selectedFile) return;
    try {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const formData = new FormData();
      formData.append("photo", selectedFile);
      formData.append("userId", storedUser._id);

      const response = await fetch(`${API_URL}/api/photos/upload`, {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        body: formData,
      });

      if (response.ok) {
        const newPhoto = await response.json();
        setPhotos((prev) => [newPhoto, ...prev]);
        setSelectedFile(null);
        setPreview(null);
      } else {
        console.error("❌ Erreur upload photo :", response.status);
      }
    } catch (error) {
      console.error("❌ Erreur lors de l’upload :", error);
    }
  };

  const handleDelete = async (photoId) => {
    try {
      const response = await fetch(`${API_URL}/api/photos/${photoId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.ok) {
        setPhotos((prev) => prev.filter((photo) => photo._id !== photoId));
      } else {
        console.error("❌ Erreur suppression photo :", response.status);
      }
    } catch (error) {
      console.error("❌ Erreur lors de la suppression :", error);
    }
  };

  return (
    <div className="p-6 bg-white shadow-md rounded-lg w-full max-w-3xl">
      <h2 className="text-2xl font-semibold mb-6">📸 Photos</h2>

      {/* 📌 Zone d'upload améliorée */}
      <div className="mb-6 flex flex-col items-center space-y-4">
        <label className="cursor-pointer bg-gray-100 border border-gray-300 text-gray-600 rounded-lg px-6 py-3 hover:bg-gray-200">
          Sélectionner une image
          <input type="file" onChange={handleFileChange} className="hidden" />
        </label>

        {preview && (
          <img src={preview} alt="Aperçu" className="w-32 h-32 rounded-lg shadow-md object-cover" />
        )}

        <button
          onClick={handleUpload}
          className={`px-6 py-3 text-white font-semibold rounded-lg shadow-md transition ${
            selectedFile ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"
          }`}
          disabled={!selectedFile}
        >
          📤 Partager
        </button>
      </div>

      {/* 📌 Affichage en mosaïque */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-6">
        {photos.length > 0 ? (
          photos.map((photo, index) => (
            <div key={index} className="relative">
              <img
                src={`${API_URL}${photo.url}`}
                alt={`Photo ${index}`}
                className="w-full h-48 object-cover rounded-lg shadow-md cursor-pointer hover:opacity-80 transition"
                onClick={() => setSelectedPhotoIndex(index)} // ✅ Ouvre le slider
              />

              <button
                onClick={() => handleDelete(photo._id)}
                className="absolute top-2 right-2 bg-red-600 text-white text-xs px-3 py-1 rounded shadow-md opacity-90 hover:opacity-100 transition"
              >
                🗑️ 
              </button>
            </div>
          ))
        ) : (
          <p className="text-gray-500 text-center col-span-3">Aucune photo pour le moment.</p>
        )}
      </div>

      {/* 📌 Slider plein écran */}
      {selectedPhotoIndex !== null && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-90 flex items-center justify-center z-50">
          {/* Bouton de fermeture */}
          <button
            onClick={() => setSelectedPhotoIndex(null)}
            className="absolute top-5 right-5 text-white text-3xl"
          >
            ✖
          </button>

          {/* Flèche gauche */}
          {selectedPhotoIndex > 0 && (
            <button
              onClick={() => setSelectedPhotoIndex(selectedPhotoIndex - 1)}
              className="absolute left-5 text-white text-3xl"
            >
              ◀
            </button>
          )}

          {/* 📌 Affichage de la photo en grand */}
          <img
            src={`${API_URL}${photos[selectedPhotoIndex].url}`}
            className="max-w-full max-h-[90vh] object-contain rounded-lg"
            alt="Full Size"
          />

          {/* Flèche droite */}
          {selectedPhotoIndex < photos.length - 1 && (
            <button
              onClick={() => setSelectedPhotoIndex(selectedPhotoIndex + 1)}
              className="absolute right-5 text-white text-3xl"
            >
              ▶
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default Photos;